import { api } from "@/lib/api";

const base = (treeId) => `/my/trees/${treeId}`;

export const treesApi = {
  list: () => api.get("/my/trees").then((r) => r.data),
  create: (name) => api.post("/my/trees", { name }).then((r) => r.data),
  rename: (id, name) => api.patch(base(id), { name }).then((r) => r.data),
  remove: (id) => api.delete(base(id)).then((r) => r.data),
  get: (id) => api.get(base(id)).then((r) => r.data),
  addPerson: (id, payload) =>
    api.post(`${base(id)}/people`, payload).then((r) => r.data),
  editPerson: (id, personId, payload) =>
    api.patch(`${base(id)}/people/${personId}`, payload).then((r) => r.data),
  deletePerson: (id, personId) =>
    api.delete(`${base(id)}/people/${personId}`).then((r) => r.data),
  addRelationship: (id, payload) =>
    api.post(`${base(id)}/relationships`, payload).then((r) => r.data),
  deleteRelationship: (id, relId) =>
    api.delete(`${base(id)}/relationships/${relId}`).then((r) => r.data),
};
